module.exports = __webpack_public_path__ + "static/media/ceo_english.4510eabd.png";